import { TableConfig } from '@shared/interfaces/table/table-config';
import { UploadStatus } from '@app/api/dmc';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { DATE_TIME_FORMAT_FULL } from '@app/core/constants/date-time-format-full';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const manualTimeseriesResultTable: TableConfig<UploadStatus> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      key: 'fileName',
      title: 'meteringpoint.csvupload.tableheaders.filename',
    },
    {
      key: 'uploadedAt',
      title: 'meteringpoint.csvupload.tableheaders.uploadeddatetime',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT_FULL,
      }
    },
    {
      key: 'status',
      title: 'meteringpoint.csvupload.tableheaders.status',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        pending: 'meteringpoint.csvupload.status.pending',
        processing: 'meteringpoint.csvupload.status.processing',
        completed: 'meteringpoint.csvupload.status.completed',
        failed: 'meteringpoint.csvupload.status.failed'
      }
    },
    {
      key: 'totalRows',
      title: 'meteringpoint.csvupload.tableheaders.totalrows',
    },
    {
      key: 'successfulRows',
      title: 'meteringpoint.csvupload.tableheaders.successfulrows',
    },
    {
      key: 'skippedLockedRows',
      title: 'meteringpoint.csvupload.tableheaders.skippedlockedrows',
    },
    {
      key: 'failedRows',
      title: 'meteringpoint.csvupload.tableheaders.failedrows',
    },
    {
      key: 'processedAt',
      title: 'meteringpoint.csvupload.tableheaders.processingtime',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT_FULL,
      }
    }
  ]
};
